export default __webpack_public_path__ + "static/media/partner-metal-core.01fcd478.png";